import bankAccountsPanel from './bankAccountsPanel.html';

/*******************************************************************************
 * @ngdoc component
 * @name  csm.books.InitialSetup.dom.component:bankAccountsPanel
 *
 * @param {expr) onLoad
 * Evaluated when component is loaded. Passes `$validator` to main app to be
 * called when validation is required.
 *
 * @param {boolean} ready
 * Ready for user control flag. Set `true` by main app is no longer busy (help
 * dialog is closed).
 *
 * @description
 * Bank accounts list panel component. Shows a grid of the bank accounts in
 * `AppData.accounts` with Add/Change/Remove buttons. If default bank account is
 * not been set up, Add/Change dialog is shown for this account when `ready`
 * turns `true`.
 *******************************************************************************/
export const bankAccountsPanelComponent = {
  bindings: { onLoad: '&', ready: '<' },
  template: bankAccountsPanel,
  controller: Controller
};

/*******************************************************************************
 * Controller
 *******************************************************************************/
/* @ngInject */ function Controller($injector, $scope) {
  var $ctrl = this;
  var $svcs = { $ctrl, $injector, $scope };
  $ctrl.$onInit = () => $injector.invoke(initCtrl, null, Object.assign($svcs, { $svcs}));
}

/*******************************************************************************
 * $ctrl.addChangeAcct */
/**
 * Add/Change button handler. Shows `BankAccountSetupDialog` for entry/edit of a
 * bank account and returns the dialog promise.
 *
 * @param {data.SetupBankAccount} info  Bank account info, `null`=Add new account.
 * @return                              Promise resolved with new account info.
 ******************************************************************************/
/* @ngInject */ function addChangeAcct(Data, BankAccountSetupDialog) {
  return function (info) {
    return BankAccountSetupDialog.show(new Data.SetupBankAccount(info));
  };
}

/*******************************************************************************
 * initCtrl */
/**
 * $ctrl property initializer.
 ******************************************************************************/
/* @ngInject */ function initCtrl($ctrl, $injector, $scope, $svcs, AppData, ArrayCollection) {
  Object.assign($ctrl, {
    acctList:      new ArrayCollection(AppData.accounts, a => a.isBankAccount),

    addChangeAcct: $injector.invoke(addChangeAcct, null, $svcs),
    validate:      $injector.invoke(validate, null, $svcs),
  });
  
  /*----------------------------------*/
  /* Send validator back to main app. */
  /*----------------------------------*/
  $ctrl.onLoad({ $validator: $ctrl.validate });

  /*----------------------------------------------------------------*/
  /* Show add/change dialog if default account has not been set up. */
  /*----------------------------------------------------------------*/
  var dereg = $scope.$watch('$ctrl.ready', function (newVal) {
    if (newVal) {
      if ($ctrl.acctList[0].lastStmtDate == null)
        $ctrl.addChangeAcct($ctrl.acctList[0]).then(function (newInfo) {
          $ctrl.acctList.replaceItem($ctrl.acctList[0], newInfo);
        });
      dereg();
    }
  });
}

/*******************************************************************************
 * $ctrl.validate */
/**
 * Called by app to validate the input before moving to the next view.
 *
 * @return {boolean}  `true`=validation successful.
 ******************************************************************************/
/* @ngInject */ function validate($ctrl, Alert) {
  return function () {
    if ($ctrl.validator) {
      Alert.clear($ctrl.validator);
      $ctrl.validator = null;
    }

    if ($ctrl.acctList[0].lastStmtDate == null)
      $ctrl.validator = Alert.error(
        'Your default bank account has not been properly set up.',
        'Unable to Continue',
        false,
        { timeOut: 5000 }
      );

    return !$ctrl.validator;
  };
}
